import React from 'react'
import { Box } from '@chakra-ui/react'

export const SideBar = () => {
  return <Box className='sidebar'></Box>
}
